export default "__VITE_ASSET__BJZmmgd2__"